  import React, { useEffect,useState } from 'react';
  import Navbar from '../Header&Footer/Navbar';
  import Footers from '../Header&Footer/Footers';
  // import {Link} from 'react-router-dom';
  // import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
  // import { faFacebookF, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
  import '../Components/waterpure.css';
  import WATERPUREHERO from '../images/WATERPUREHERO.jpg'
  import WATERPURDESC from '../images/WATERPURDESC.jpg'

  // import PHONECALLPNG from '../images/PHONECALLPNG.png'
  // import EMAILPNG from '../images/EMAILPNG.png'
  import PURITECH from '../images/PURITECH.jpg'
  // import WHATSAPPPNG from '../images/WHATSAPPPNG.png'
  // import { Helmet } from 'react-helmet';
  import AOS from 'aos';
  import 'aos/dist/aos.css';


  export default function WATERPURIFIERSERVICE() {


    useEffect(() => {
      window.scrollTo(0, 0); 
      document.title = "Water Purifier Service";
    }, []);
  useEffect(() => {
                  AOS.init({ duration: 1000, once: true });
                }, []);




  
      const [formData, setFormData] = useState({
        name: "",
        phone: "",
        
        location: "",
        appliance: "",
        issue: "",
      });
    
      const [loading, setLoading] = useState(false);
    
      const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone") {
          const v = value.replace(/\D/g, "").slice(0, 10);
          setFormData((p) => ({ ...p, phone: v }));
        } else {
          setFormData((p) => ({ ...p, [name]: value }));
        }
      };
    
      const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
          ...formData,
          name: formData.name.trim(),
          phone: formData.phone.trim(),
          location: formData.location.trim(),
          issue: `  ${formData.issue.value}
        
        - this offline calls coming from servicee2e.in 
        `, 
          toMail: "expresshelplinecare@gmail.com",
        };
    
        if (!payload.name || !payload.phone || !payload.location) {
          alert("Please fill all required fields.");
          return;
        }
        if (!/^[6-9]\d{9}$/.test(payload.phone)) {
          alert("Enter a valid 10-digit Indian mobile number.");
          return;
        }
        // if (payload.email && !/^\S+@\S+\.\S+$/.test(payload.email)) {
        //   alert("Enter a valid email address.");
        //   return;
        // }
    
        setLoading(true);
        try {
          const res = await fetch("https://form.e2ecrm.in/api/sendmail", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          });
          const data = await res.json().catch(() => ({}));
          if (res.ok) {
            alert(data?.message || "Booking submitted successfully!");
            setFormData({ name: "", phone: "",  location: "", appliance: "", issue: "" });
          } else {
            alert(data?.message || "Something went wrong. Please try again.");
          }
        } catch (err) {
          console.error(err);
          alert("Failed to submit booking.");
        } finally {
          setLoading(false);
        }
      };


    



    return (
      <>
                          <div>
                                  <Navbar />
                                </div>
                          
                  



          {/* <section className="highlight-strip">
    <div className="scroll-container" direction="left">
      <div className="scroll-track">
        <div className="scroll-content">
          🚚 Free Visit Within 5 KM &nbsp;&nbsp;&nbsp;
          🛠️ Up to-1 Year Spare Warranty &nbsp;&nbsp;&nbsp;
          🧰 Transparent Spare Parts Pricing &nbsp;&nbsp;&nbsp;
          🔁 30 Days Money Back If Not Satisfied * &nbsp;&nbsp;&nbsp;
        </div>
        <div className="scroll-content" direction="left">
          🚚 Free Visit Within 5 KM &nbsp;&nbsp;&nbsp;
          🛠️ Up to-1 Year Spare Warranty &nbsp;&nbsp;&nbsp;
          🧰 Transparent Spare Parts Pricing &nbsp;&nbsp;&nbsp;
          🔁 30 Days Money Back If Not Satisfied * &nbsp;&nbsp;&nbsp;
        </div>
        <div className="scroll-content" direction="left">
          🚚 Free Visit Within 5 KM &nbsp;&nbsp;&nbsp;
          🛠️ Up to-1 Year Spare Warranty &nbsp;&nbsp;&nbsp;
          🧰 Transparent Spare Parts Pricing &nbsp;&nbsp;&nbsp;
          🔁 30 Days Money Back If Not Satisfied * &nbsp;&nbsp;&nbsp;
        </div>
      </div>
    </div>
  </section> */}


                          
                                <section id="hero" style={{ backgroundImage: `url(${WATERPUREHERO})` }}>
                                    <div className="hero-content reveal up">
    {/* 🔹 Hero Text */}
    <div className="hero-text animate__animated animate__fadeInLeft">
      {/* <h1 className="shine">WE ARE READY TO HELP</h1> */}
       <h1 className="shine">Water Purifier Service</h1>
      <h3 className="reveal up delay-1">Fast And Reliable Service</h3>
      <a
        href="tel:+91777 000 5768"
        className="hero-btn reveal up delay-2"
      >
         +91777 000 5768
      </a>
    </div>

    {/* 🔹 Form */}
    <div className="form-container animate__animated animate__fadeInRight">
      <form className="form-card" onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="tel"
          name="phone"
          placeholder="Phone Number"
          value={formData.phone}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Your Email (optional)"
          value={formData.email}
          onChange={handleChange}
        />
        <input
          type="text"
          name="location"
          placeholder="Your Address"
          value={formData.location}
          onChange={handleChange}
          required
        />
        <textarea
          name="issue"
          rows="3"
          placeholder="Describe the Issue"
          value={formData.issue}
          onChange={handleChange}
        ></textarea>
        <button type="submit" className="btn-glow" disabled={loading}>
          {loading ? "Submitting..." : "📞 Submit"}
        </button>
      </form>
    </div>
  </div>
                                  </section>
                          
                      
                      
                      
                            <section id="start" data-aos="zoom-in">
                        <div className="container">
                          <div className="row">
                            <div className="col-12 text-center">
                              <div className="line-container">
                                <div className="line left-line"></div>
                                <div className="star">&#9733;</div> {/* Star symbol */}
                                <div className="line right-line"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      
                      
                      
                      
                      
                      
                      
                      
                      <section id="WRHY" data-aos="fade-left">
                        <div className='container'>
                          <div className='row'>
                            <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                      
                            <h2 data-aos="fade-right">We Are Ready To Help You</h2>
                      
                            </div>
                      </div>
                      </div>
                      </section>
                      
                      
                      <section id="LIST" data-aos="fade-left">
                        <div className='container'>
                          <div className='row'>
                            <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                      
                              <h2 data-aos="fade-right">Customer Care Helpline Support</h2>
                              <ul>
                            <li> <i class='fas fa-arrow-circle-right'></i>Book Your Complaints For Quality Service</li>
            <li> <i class='fas fa-arrow-circle-right'></i>We Aim to Complete Service on the Same Day</li>
            <li> <i class='fas fa-arrow-circle-right'></i>Well Skill Trained Technicians</li>
            <li> <i class='fas fa-arrow-circle-right'></i>Quality Service Affordable Price</li>
            <li> <i class='fas fa-arrow-circle-right'></i>Door Step Service Center</li>
            <li> <i class='fas fa-arrow-circle-right'></i>Trusted Professional Technicians</li>

                              </ul>
                      
                              <h2 data-aos="fade-left">Issues In Water Purifier</h2>
                              <ul>
                                <li> <i class='fas fa-arrow-circle-right'></i>On-Off Problem</li>
                                <li> <i class='fas fa-arrow-circle-right'></i>RO Purifier Not Working</li>
                                <li> <i class='fas fa-arrow-circle-right'></i>Water Leakage</li>
                                <li> <i class='fas fa-arrow-circle-right'></i>Foul Odour or Bad Taste of Water.</li>
                                <li> <i class='fas fa-arrow-circle-right'></i>Auto Shut-Off Failure</li>
                                <li> <i class='fas fa-arrow-circle-right'></i>Low Water Flow or Storage Tank Taking More Time to Fill</li>
                                <li> <i class='fas fa-arrow-circle-right'></i>Vibrations or Noise in RO Purifiers</li>
                                
                              </ul>
                      
                              <h2 data-aos="fade-right">Types Of Water Purifier</h2>
                              <ul>
                                <li> <i class='fas fa-arrow-circle-right'></i>Single Container Water Purifier Service</li>
                                <li> <i class='fas fa-arrow-circle-right'></i>Dual Container Water Purifier Service</li>
                                <li> <i class='fas fa-arrow-circle-right'></i>Three Container Water Purifier Service</li>
                                <li> <i class='fas fa-arrow-circle-right'></i>10 Ltr Water Heater Service  </li>
                                <li> <i class='fas fa-arrow-circle-right'></i>Commercial Container Water Purifier Service</li>
                              
                              </ul>
                            </div>
                          </div>
                        </div>
                      </section>
                      
                      
                      <section id="WRHY" data-aos="fade-right">
                        <div className='container'>
                          <div className='row'>
                            <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                      
                            <h2 data-aos="zoom-in">Why Choose Us?</h2>
                      
                            </div>
                      </div>
                      </div>
                      </section>
                      <section id="WASHMANSIT" data-aos="fade-right">
                        <div className='container'>
                          <div className='row'>
                            <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                              <center>
                          <img src={PURITECH}  data-aos="fade-left" alt="washing machine service" title="washing machine service"/>
                          </center>
                        <p>We are a Fast and Reliable Water Purifier Service Center. We handle all types of RO, UV, and UF water purifiers with doorstep service across Tamil Nadu. Book your complaint for same-day service. We focus on quality service and use Replacement Parts to help maintain purification efficiency and customer satisfaction.</p>

                      
                            </div>
                      </div>
                      </div>
                      </section>
                      
                      
                      
                      {/* <section id="WRHY">
                        <div className='container'>
                          <div className='row'>
                            <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                      
                            <h2>Why Choose Us?</h2>
                      
                            </div>
                      </div>
                      </div>
                      </section> */}
                      <section id="STARS" data-aos="zoom-out">
                        <div className='container'>
                          <div className='row'>
                          
                          
                            <div className='col-lg-4 col-md-4 col-sm-12 col-12'>
                              <center id="border">
                            <div className="star" id="STARRATE">&#9733;</div>
                            <h5>Fast And Reliable Service</h5>
                            </center>
                            </div>
                            <div className='col-lg-4 col-md-4 col-sm-12 col-12'>
                              <center id="border">
                            <div className="star" id="STARRATE">&#9733;</div>
                            <h5>Water Purifier Service Center</h5>
                            </center>
                            </div>
                            <div className='col-lg-4 col-md-4 col-sm-12 col-12'>
                              <center id="border">
                            <div className="star" id="STARRATE">&#9733;</div>
                            <h5>Get Your Service Done the Same Day</h5>
                            </center>
                            </div>
                            
                      </div>
                      </div>
                      </section>
                      
                      
                      
                      
                      
                      
                      
                      
                      
                      
                      
                      
                      {/* <section id="WRHY">
                        <div className='container'>
                          <div className='row'>
                            <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                      
                            <h2>Customer Testimonials</h2>
                      
                            </div>
                      </div>
                      </div>
                      </section>
                      
                      
                      <section id="RATING">
                        <div className='container'>
                          <div className='row'>
                            <div className='col-lg-3 col-md-3 col-sm-12 col-12' id="borders">
                            <p>Good  LG washing machine service. i like this quick service response. good customer relationship management.</p>
                            <center>
                            <span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span>
                            </center>
                            <h5>Kumar, Madurai</h5>
                            </div>
                            
                            <div className='col-lg-3 col-md-3 col-sm-12 col-12' id="borders">
                            <p>Quick Good service response. quality  fridge service with affordable price. thank u</p>
                            <center>
                            <span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span>
                            </center>
                            <h5>Siva Rangini, Chennai</h5>
                            </div>
                            <div className='col-lg-3 col-md-3 col-sm-12 col-12' id="borders">
                            <p>Brilliant Service. My Work is done Quick and At Least Cost Possible. Personally, I Loved the Service. Keep It Up ❤️</p>
                            <center>
                            <span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span>
                            </center>
                            <h5>R.Muthu Raghavan, Tirchy</h5>
                            </div>
                            <div className='col-lg-3 col-md-3 col-sm-12 col-12' id="borders">
                            <p>The service is Good and also at affordable charge. The AC which I serviced few days back, working at great condition. Also They finished the service quick. Thankyou</p>
                            <center>
                            <span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span>
                            </center>
                            <h5>Manoj Kumar, Tirunelveli</h5>
                            
                            </div>
                      
                      
                      
                            <div className='col-lg-3 col-md-3 col-sm-12 col-12' id="borders">
                            <p>Done LG washing machine service in my home perfectly….
                            I love that technician’s response so much….</p>
                            <center>
                            <span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span>
                            </center>
                            <h5>Murugan, Thanjavur</h5>
                            </div>
                            
                            <div className='col-lg-3 col-md-3 col-sm-12 col-12' id="borders">
                            <p>This service center is very responsible. I’ve called them for my  LG washing Machine service and they’d service work very quick and professionally</p>
                            <center>
                            <span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span>
                            </center>
                            <h5>Selvi, Coimbatore</h5>
                            </div>
                            <div className='col-lg-3 col-md-3 col-sm-12 col-12' id="borders">
                            <p>We Do our Fridge Service from this center. Service is Quick and worth for Cost</p>
                            <center>
                            <span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span>
                            </center>
                            <h5>Abdul Rahuman, Theni</h5>
                            </div>
                            <div className='col-lg-3 col-md-3 col-sm-12 col-12' id="borders">
                            <p>Washing Machine service is good and very professional and they have proper billing details and cost efficient</p>
                            <center>
                            <span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span>
                            </center>
                            <h5>Ranjith Kumar, Pondicherri</h5>
                            
                            </div>
                      
                      
                      
                      
                      
                      
                      
                      
                            <div className='col-lg-3 col-md-3 col-sm-12 col-12' id="borders">
                            <p>Service made for  good service made, very responsive , low cost, one of the best service center.
                            Service’s are core to professional , good communication skills.</p>
                            <center>
                            <span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span>
                            </center>
                            <h5>Sathis Raja, Salem</h5>
                            </div>
                            
                            <div className='col-lg-3 col-md-3 col-sm-12 col-12' id="borders">
                            <p>Customer service for good , customer service for  LG washing machine is good. Experienced technician</p>
                            <center>
                            <span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span>
                            </center>
                            <h5>Kavi Kumar, Cuddalore</h5>
                            </div>
                            <div className='col-lg-3 col-md-3 col-sm-12 col-12' id="borders">
                            <p>They have serviced our fridge Machine, service is professional and quick and worth for cost</p>
                            <center>
                            <span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span>
                            </center>
                            <h5>Sky Ans, Ramnathapuram</h5>
                            </div>
                            <div className='col-lg-3 col-md-3 col-sm-12 col-12' id="borders">
                            <p>I’m sure about this center has the LG washing machine service at very low cost</p>
                            <center>
                            <span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span><span class="fa fa-star checked"></span>
                            </center>
                            <h5>S.Deepak, Erode</h5>
                            
                            </div>
                      
                      
                      <p>With over 11 years of dedicated experience in the industry, Our Service Center is your trusted partner for all Water Purifier service needs. Since our inception, we have committed ourselves to delivering top-notch, reliable, and efficient services, ensuring that your appliances operate at their best.</p>
                      
                      </div>
                      </div>
                      </section> */}
                      
                      
                      
                      
                      
                      
                      <section id="ours" data-aos="fade-right">
                        <div className='container'>
                          <div className='row'>
                            <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                      
                            <h5 data-aos="zoom-in">Our Mission</h5>
                          <p>
    Our mission is to deliver exceptional service through our expertise and commitment to customer satisfaction. We minimize inconvenience with prompt, professional water purifier repairs and support.
  </p>

                            </div>
                      </div>
                      </div>
                      </section>
                      
                      
                      
                      <section id="DESCWASH" data-aos="fade-left">
                        <div className='container'>
                          <div className='row'>
                            <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                      
                            <img src={WATERPURDESC} className="img-fluid" alt="washing machine service" title='washing machine service'/>
                      
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12 col-12'>
                      
                          <h3>
                          Water Purifier Customer Support Service</h3>
                          <ul>
                        <li><strong>Technical Assistance:</strong> Troubleshoot common water purifier issues: low water flow, noise, leakage, filter or membrane faults.</li>
  <li><strong>Installation Support:</strong> Guidance on proper water purifier installation, inlet/outlet setup, and wall mounting.</li>
  <li><strong>Maintenance Advice:</strong> Tips on filter replacement schedules, regular cleaning, and maintaining water purification efficiency.</li>

                          </ul>
                            </div>
                      </div>
                      </div>
                      </section>
                      
                      
                      {/* <section id="call-btn">
                                <div className='container'>
                                  <div className='row'>
                                    <div className='col-lg-12 colmd-12 col-sm-12 col-12'>
                                      <center>
                                      <a href='tel:+91777 000 5768'><button>+91777 000 5768</button></a>
                                      </center>
                                    </div>
                                  </div>
                                </div>
                              </section>
                      */}
                      
                      
                      
                              <section id="WWO" data-aos="fade-left">
                                <div className='container'>
                                  <div className='row'>
                                    <div className='col-lg-12 colmd-12 col-sm-12 col-12'>
                                      <h5 data-aos="zoom-in">What We Offer</h5>
                                    <p><strong>Expert Technicians:</strong> Our team includes experienced and skilled technicians with in-depth knowledge of all types of water purifiers, including RO, UV, UF, and gravity-based models.</p>
  <p><strong>Comprehensive Services:</strong> From regular maintenance to complex water purifier repairs, we handle every aspect of servicing with care and precision.</p>
  <p><strong>Customer-Centric Approach:</strong> We focus on your needs and provide personalized service solutions to ensure a smooth and satisfying experience.</p>
  <p><strong>Quality Assurance:</strong> We use Replacement Parts and follow high service standards to help maintain your water purifier’s performance and water quality.</p>
  <p><strong>Affordable Pricing:</strong> Our water purifier services are reasonably priced, offering dependable support without exceeding your budget.</p>

                                    </div>
                                  </div>
                                </div>
                              </section>
  {/*                     
                              <section id="call-btn">
                                <div className='container'>
                                  <div className='row'>
                                    <div className='col-lg-12 colmd-12 col-sm-12 col-12'>
                                      <center>
                                      <a href='tel:+91777 000 57681'><button>+91777 000 5768</button></a>
                                      </center>
                                    </div>
                                  </div>
                                </div>
                              </section> */}
                      
                      
                      
                      <div><Footers/></div>
                      
                              </>
    )
  }
